var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13.67,
    height: 18.284,
    viewBox: "0 0 13.67 18.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf-icon",
    transform: "translate(-66.1 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38002",
    "data-name": "Path 38002",
    d: "M79.766,6.287,75.483,2H66.791a.691.691,0,0,0-.691.691V14.954H79.766Z",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38003",
    "data-name": "Path 38003",
    d: "M326.8,5.6a.691.691,0,0,0,.691.691h3.6L326.8,2Z",
    transform: "translate(-251.317 0)",
    fill: "#dbdfe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38004",
    "data-name": "Path 38004",
    d: "M66.2,361.8v4.643a.691.691,0,0,0,.691.691H79.175a.691.691,0,0,0,.691-.691V361.8Z",
    transform: "translate(-0.096 -346.85)",
    fill: "#f1786b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12266",
    "data-name": "Group 12266",
    transform: "translate(68.472 3.681)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38005",
    "data-name": "Path 38005",
    d: "M132.964,59.184a.97.97,0,0,1-.626-.245.81.81,0,0,1-.32-.781c.158-.925,1.879-1.771,2.879-2.188a32.884,32.884,0,0,0,1.307-4.164,4.086,4.086,0,0,1-.608-2.631.7.7,0,0,1,.533-.468l.036-.007.036,0a.777.777,0,0,1,.493.324,2.3,2.3,0,0,1,.18,1.767c-.043.23-.115.561-.209.957a22.786,22.786,0,0,0,1.893,3.182,5.946,5.946,0,0,1,1.407-.054c.767.079.929.414.957.608a.737.737,0,0,1-.522.731,1.658,1.658,0,0,1-1.954-.695c-.029-.036-.058-.076-.086-.115a15.624,15.624,0,0,0-2.815.777l-.306.119c-.673,1.648-1.332,2.6-1.962,2.822A.861.861,0,0,1,132.964,59.184Zm1.692-2.631c-1.429.644-2.138,1.281-2.2,1.681a.369.369,0,0,0,.169.371.487.487,0,0,0,.511.112C133.633,58.537,134.166,57.673,134.655,56.553Zm4.211-1.213a1.194,1.194,0,0,0,1.364.475c.173-.072.27-.194.259-.263s-.173-.194-.569-.234a5.3,5.3,0,0,0-1.055.022Zm-2.361-2.93c-.22.846-.518,1.864-.867,2.851-.061.169-.119.331-.18.489a16.99,16.99,0,0,1,2.62-.738A23.8,23.8,0,0,1,136.505,52.411Zm-.324-3.257a.26.26,0,0,0-.169.176,3.011,3.011,0,0,0,.36,1.767q.043-.205.076-.378c.166-.9.007-1.281-.1-1.429A.4.4,0,0,0,136.181,49.153Z",
    transform: "translate(-132.006 -48.7)",
    fill: "#f1786b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12267",
    "data-name": "Group 12267",
    transform: "translate(69.4 15.94)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_38006",
    "data-name": "Path 38006",
    d: "M309.382,390.7h-.824v-.839h.824a.281.281,0,0,0,0-.561h-1.1a.281.281,0,0,0-.281.281v2.793a.281.281,0,1,0,.561,0v-1.116h.824a.279.279,0,1,0,0-.558Z",
    transform: "translate(-302.594 -389.3)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38007",
    "data-name": "Path 38007",
    d: "M158.649,389.4h-.569a.281.281,0,0,0-.281.281v2.793a.281.281,0,0,0,.561,0v-1.116h.288a.979.979,0,0,0,0-1.958Zm0,1.4h-.288v-.839h.288a.419.419,0,0,1,0,.839Z",
    transform: "translate(-157.8 -389.396)",
    fill: "#eff3f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38008",
    "data-name": "Path 38008",
    d: "M221.215,389.4h-.734a.281.281,0,0,0-.281.281v2.793a.281.281,0,0,0,.281.281h.734a1.677,1.677,0,1,0,0-3.354Zm0,2.789h-.454v-2.235h.454a1.118,1.118,0,0,1,0,2.235Z",
    transform: "translate(-217.954 -389.396)",
    fill: "#eff3f5"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.4e1971a2.svg";
export { ForwardRef as ReactComponent };